import { createGlobalStyle } from 'styled-components'
import { giphyLightGrey } from './colors'

const LandingPageGlobalStyles = createGlobalStyle`
    body {
        background: black;
        color: white;
    }

    p {
        font-size: 20px;
        line-height: 28px;
        color: ${giphyLightGrey};
    }
`

export default LandingPageGlobalStyles
